export const MANUAL_BATCH_ENTRY_METHODS = ["cash", "check"] as const;
export const RECORDED_CONTRIBUTION_METHODS = ["cash", "check", "credit_card", "ach"] as const;
export type ContributionEntryMethod = typeof RECORDED_CONTRIBUTION_METHODS[number];

export function isCashOrCheckMethod(value: unknown): value is "cash" | "check" {
  return value === "cash" || value === "check";
}

export function isContributionEntryMethod(value: unknown): value is ContributionEntryMethod {
  return isCashOrCheckMethod(value) || value === "credit_card" || value === "ach";
}

export function contributionEntryMethodLabel(method: ContributionEntryMethod): string {
  return { cash: "Cash", check: "Check", credit_card: "Card", ach: "ACH" }[method];
}

export function contributionEntryMethodOptionLabel(method: ContributionEntryMethod): string {
  const label = contributionEntryMethodLabel(method);
  return isCashOrCheckMethod(method) ? label : `${label} (record only)`;
}

export function contributionEntryMethodTallyLabel(method: ContributionEntryMethod): string {
  return method === "check" ? "Checks" : contributionEntryMethodLabel(method);
}

export function summarizeContributionMethods(entries: readonly { method: ContributionEntryMethod; amount: number }[]) {
  const summary: Record<ContributionEntryMethod, { count: number; amount: number }> = {
    cash: { count: 0, amount: 0 }, check: { count: 0, amount: 0 },
    credit_card: { count: 0, amount: 0 }, ach: { count: 0, amount: 0 },
  };
  for (const entry of entries) {
    summary[entry.method].count += 1;
    summary[entry.method].amount += entry.amount;
  }
  return summary;
}
